import React, { Component } from 'react';
import './Index.css';
import { Link } from 'react-router-dom';

const recipes = require('../res/recipes.json');

class Index extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.props.loadRecipes();
    }

    sortRecipes(recipes) {
        return recipes.sort(function(a, b) {
            const titleA = a.title.toUpperCase();
            const titleB = b.title.toUpperCase();
            return (titleA < titleB) ? -1 : (titleA > titleB) ? 1 : 0;
        });
    }

    render() {
        // const { recipes } = this.props;
        return (
            <div className="index-container">
                <p className="index-title">	Index des recettes :</p>
                <div className="index-recipes">
                    { this.sortRecipes(recipes).map(recipe =>
                        <Link to={`/recette/${recipe.label}`}
                              key={recipe.id}
                              className="index-recipe--link">
                            <div className="index-recipe">
                                { recipe.title }
                            </div>
                        </Link>
                    )}
                </div>
            </div>
        );
    }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Index.js